var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c(
        "el-menu",
        {
          attrs: { "default-active": _vm.activeItem, mode: "horizontal" },
          on: { select: _vm.clickMenu },
        },
        [
          _c("el-menu-item", { attrs: { index: "main" } }, [
            _vm._v("Категории/Товары"),
          ]),
          _vm._v(" "),
          _c("el-menu-item", { attrs: { index: "contact" } }, [
            _vm._v("Контактная информация"),
          ]),
          _vm._v(" "),
          _c("el-menu-item", { attrs: { index: "misc" } }, [
            _vm._v("Дополнительно"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }